import { Component, OnInit, Input, OnChanges } from "@angular/core";
import { UploadMultipleFilesService } from "@fiduciaria/RequestCreation/Services/upload-multiple-files.service";
import { DocumentFile } from "@fiduciaria/RequestCreation/Types/document-file";
import { DocumentFileGroup } from "@fiduciaria/RequestCreation/Types/document-file-group";
import { Observable } from "rxjs";

import { ModalTitles, ModalType } from "@shared/Constantes/modal.constantes";
import { File } from "@shared/Entities/General/file.entity";
import { ModalService } from "@shared/Services/modal.service";

import { RequestCreationFormService } from "../../Services/request-creation-form.service";
import { CreationRequest } from "../../Types/Interfaces/new-request-creation.interface";

@Component({
  selector: "app-side-summary",
  templateUrl: "./side-summary.component.html",
})
export class SideSummaryComponent implements OnInit, OnChanges {
  public creationRequest$: Observable<CreationRequest>;
  @Input() private currentFilesUploaded: DocumentFile[];
  @Input() private currentFilesList: DocumentFile[];
  @Input() private setCurrentFilesUploaded: (files: DocumentFile[]) => void;
  private filesGroups: DocumentFileGroup[];
  private _filesSizeMegaBytes: number;
  private _filesSizeMegaBytes1X1: number;

  public get filesSizeMegaBytes(): number {
    return this._filesSizeMegaBytes;
  }

  public get filesSizeMegaBytes1X1(): number {
    return this._filesSizeMegaBytes1X1;
  }

  constructor(
    private requestCreationFormService: RequestCreationFormService,
    private modalService: ModalService,
    private uploadMultipleFilesService: UploadMultipleFilesService
  ) {}

  public ngOnInit(): void {
    this.creationRequest$ = this.requestCreationFormService.value;
    this.currentFilesUploaded = [];
    this.currentFilesList = [];
    this.filesGroups = [];
    this._filesSizeMegaBytes = 0;
  }

  public ngOnChanges(): void {
    this.setFilesGroups(this.currentFilesList, this.currentFilesUploaded);
  }

  private setFilesGroups(filesList: DocumentFile[], filesUploaded: DocumentFile[]): void {
    filesList = filesList ?? [];
    filesUploaded = filesUploaded ?? [];
    this.filesGroups = this.uploadMultipleFilesService.groupFilesByReferenceName([...filesList, ...filesUploaded]);
    this._filesSizeMegaBytes = this.getFilesSizeMegaBytes(filesList.concat(filesUploaded));
    this._filesSizeMegaBytes1X1 = this.getFilesSizeMegaBytes1x1(filesList.concat(filesUploaded));
  }

  private isMainFile(file: DocumentFile): boolean {
    return this.currentFilesList.some((x) => x.file === file.file);
  }

  private getSizeMegaBytes(bytes: number, digits: number): number {
    return this.uploadMultipleFilesService.getSizeMegaBytes(bytes, digits);
  }

  private getFilesSizeMegaBytes(files: DocumentFile[]): number {
    let sizeBytes: number = 0;
    if (!files?.length) return sizeBytes;

    for (const file of files) {
      sizeBytes += file?.file?.object?.size ?? 0;
    }

    const sizeMegaBytes: number = this.getSizeMegaBytes(sizeBytes, 3);
    return sizeMegaBytes;
  }

  private getFilesSizeMegaBytes1x1(files: DocumentFile[]): number {
    return this.uploadMultipleFilesService.getFilesSizeMegaBytes1X1(files, 3);
  }

  private getDocumentsCount(): number {
    return this.currentFilesList.length + this.currentFilesUploaded.length;
  }

  private removeFileUploaded(file: File): void {
    const msg: string = `Quiere remover el archivo <b>${file.name}</b>`;
    this.modalService
      .showConfirm({
        title: ModalTitles.warning,
        body: `¿${msg}?`,
        type: ModalType.warning,
      })
      .subscribe((ok) => {
        if (ok) {
          this.currentFilesUploaded = this.currentFilesUploaded.filter((x) => x.file !== file);
          this.setCurrentFilesUploaded(this.currentFilesUploaded);
        }
      });
  }
}
